import { render, staticRenderFns } from "./uninspectedPolicy.vue?vue&type=template&id=726f9409&scoped=true"
import script from "./uninspectedPolicy.vue?vue&type=script&lang=js"
export * from "./uninspectedPolicy.vue?vue&type=script&lang=js"
import style0 from "./uninspectedPolicy.vue?vue&type=style&index=0&id=726f9409&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726f9409",
  null
  
)

export default component.exports